// Mock数据：聊天记录数组
const mockChatMessages = [
    {
        sessionId: "sess_001",
        createdAt: "2025-08-20T10:30:00Z",
        chatCount: 24,
        sessionName: "客厅智能音箱",
        sessionMac: "A1:B2:C3:D4:E5:F6",
        sessionDevice: "XZ-AI-001",
    },
    {
        sessionId: "sess_002",
        createdAt: "2025-08-21T14:15:00Z",
        chatCount: 18,
        sessionName: "卧室助手",
        sessionMac: "B2:C3:D4:E5:F6:A7",
        sessionDevice: "XZ-AI-002",
    },
    {
        sessionId: "sess_003",
        createdAt: "2025-08-22T09:45:00Z",
        chatCount: 32,
        sessionName: "厨房终端",
        sessionMac: "C3:D4:E5:F6:A7:B8",
        sessionDevice: "XZ-AI-003",
    },
    {
        sessionId: "sess_004",
        createdAt: "2025-08-22T16:20:00Z",
        chatCount: 15,
        sessionName: "办公室设备",
        sessionMac: "D4:E5:F6:A7:B8:C9",
        sessionDevice: "XZ-AI-004",
    },
    {
        sessionId: "sess_005",
        createdAt: "2025-08-23T11:10:00Z",
        chatCount: 42,
        sessionName: "儿童房助手",
        sessionMac: "E5:F6:A7:B8:C9:D0",
        sessionDevice: "XZ-AI-005",
    },
    {
        sessionId: "sess_006",
        createdAt: "2025-08-24T08:35:00Z",
        chatCount: 19,
        sessionName: "车库终端",
        sessionMac: "F6:A7:B8:C9:D0:E1",
        sessionDevice: "XZ-AI-006",
    },
    {
        sessionId: "sess_007",
        createdAt: "2025-08-24T18:50:00Z",
        chatCount: 27,
        sessionName: "门厅设备",
        sessionMac: "A7:B8:C9:D0:E1:F2",
        sessionDevice: "XZ-AI-007",
    },
    {
        sessionId: "sess_008",
        createdAt: "2025-08-25T13:25:00Z",
        chatCount: 11,
        sessionName: "书房助手",
        sessionMac: "B8:C9:D0:E1:F2:A3",
        sessionDevice: "XZ-AI-008",
    },
    {
        sessionId: "sess_009",
        createdAt: "2025-08-25T20:40:00Z",
        chatCount: 36,
        sessionName: "阳台终端",
        sessionMac: "C9:D0:E1:F2:A3:B4",
        sessionDevice: "XZ-AI-009",
    },
    {
        sessionId: "sess_010",
        createdAt: "2025-08-26T07:55:00Z",
        chatCount: 14,
        sessionName: "庭院设备",
        sessionMac: "D0:E1:F2:A3:B4:C5",
        sessionDevice: "XZ-AI-010",
    },
];

export default mockChatMessages;
